"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assetProperties = exports.assetDownloadProperties = void 0;
exports.trackDownloadForMarketo = trackDownloadForMarketo;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MARKETO_SUBJECT = 'Anypoint Exchange Interaction';
var assetProperties = exports.assetProperties = function assetProperties(_ref) {
  var asset = _ref.asset;
  return {
    organizationId: asset.organization.id,
    groupId: asset.groupId,
    assetId: asset.assetId,
    version: asset.version,
    name: asset.name,
    type: asset.type,
    originalFormat: asset.originalFormat,
    originalFormatVersion: asset.originalFormatVersion
  };
};
var assetDownloadProperties = exports.assetDownloadProperties = function assetDownloadProperties(_ref2) {
  var asset = _ref2.asset,
    file = _ref2.file,
    isInstall = _ref2.isInstall;
  return _objectSpread(_objectSpread({}, assetProperties({
    asset: asset
  })), {}, {
    classifier: file.classifier,
    isInstall: isInstall
  });
};
function trackDownloadForMarketo(_ref3) {
  var asset = _ref3.asset,
    profile = _ref3.profile,
    isStudio = _ref3.isStudio,
    studioMetadata = _ref3.studioMetadata;
  if (!profile || !profile.marketoKey) return;
  var labels = (asset.labels || []).join(',');
  var attributes = (asset.attributes || []).map(function (_ref4) {
    var value = _ref4.value;
    return value;
  }).join(',');
  var payload = {
    subject: MARKETO_SUBJECT,
    Email: profile.email,
    id: profile.id,
    username: profile.username,
    FirstName: profile.firstName,
    LastName: profile.lastName,
    Company: profile.organization.name,
    exchangeAuthorName: asset.organization.name,
    exchangeObjectName: asset.name,
    exchangeObjectType: asset.type,
    exchangeAssetTags: "".concat(labels, ",").concat(attributes),
    isInstall: isStudio
  };
  if (isStudio) {
    payload.StudioVersion = studioMetadata.version;
  }

  // @ts-ignore
  var _global = global,
    Munchkin = _global.Munchkin;
  if (Munchkin) {
    Munchkin.munchkinFunction(Munchkin.ASSOCIATE_LEAD, payload, profile.marketoKey);
  }
}
//# sourceMappingURL=utils.js.map